// @react/hooks/useProjectEpic.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectEpicStore } from '@core/stores';

/**
 * React hook for Epic operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectEpic } from '@react/hooks';
 *
 * const EpicList = observer(() => {
 *   const store = useProjectEpic();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectEpic() {
  return projectEpicStore;
}
